<mat-toolbar>
  <h3>{{ 'scheduler.setup.roster.runHistory.title' | translate }}</h3>
  <span class="spacer"></span>
  <button (click)="runNow()" color="accent" mat-flat-button>{{ 'scheduler.setup.roster.runNow' | translate }}</button>
</mat-toolbar>
<div class="grid-container">
  <app-grid (gridEvents)="onEvent($event)" [columns]="columns" [filter]="true" [showContextMenu]="true"
    [showDirty]="true" [showRemoveRowInContextMenu]="false" [store]="gridStore" [width]="'calc(100vw)'"></app-grid>
</div>
<mat-paginator (page)="pageEvent = $event; selectPage();" [length]="gridStore.remoteTotal"
  [pageIndex]="gridStore.currentPage - 1" [pageSizeOptions]="pageSizeOptions" [pageSize]="gridStore.pageSize"
  hidePageSize="false" showFirstLastButtons="true">
</mat-paginator>